interface GetInviteLinkParams {
  baseUrl: string;
  programId: string;
}

export function getInviteLink({
  baseUrl,
  programId,
}: GetInviteLinkParams): string {
  return `${baseUrl}/_serverless/challenges-web-serverless/redirect-invite-link?programId=${programId}`;
}
